import React from 'react'
import ProductKits from './ProductKits'
import { Avatar, Tooltip, Typography } from 'antd'
import { CloseCircleOutlined, StopOutlined, UserOutlined } from '@ant-design/icons'
import AddonIcon from "assets/icons/addon.png";
import SubmittedKits from './SubmittedKits';

const { Title, Text } = Typography

export default function ProductInventory({
    kits, isLoading, isFetched, product, hasPreferenceCard, wasFound, registerForm,
    addSkuLot, removeSkuLot
    // , submittedKits, isSubmitted
}) {



    return (
        <>
            <div className="kitSearch">
                <div className="userInfo">
                    <Avatar
                        size={45} icon={<UserOutlined />}
                        style={{ backgroundColor: "#f5f2ef", }}
                        src={AddonIcon}
                    />
                    <div className="names">
                        <Title>{product?.productName}</Title>
                    </div>
                </div>
                <div
                    className="controls"
                    style={{
                        display: "flex",
                        gap: 16,
                    }}
                >
                    {!hasPreferenceCard && isFetched && (
                        <Tooltip title="Fetch preference card is disabled from product settings">
                            <StopOutlined
                                style={{ color: "#f5222d", fontSize: 20 }}
                            />
                        </Tooltip>
                    )}
                    {!wasFound && isFetched && (
                        <Tooltip title="Preference card not found in ArbiMeds">
                            <CloseCircleOutlined
                                style={{ color: "#f5222d", fontSize: 20 }}
                            />
                        </Tooltip>
                    )}
                </div>
            </div>
            {
                !isFetched && <Text style={{ marginBottom: 16, display: "inline-block" }}>
                    No content fetched yet.
                </Text>
            }
            {
            }
            {/* {
                isFetched && isSubmitted && <SubmittedKits
                    submittedKits={submittedKits}
                    preferenceCard={kits}
                />
            } */}

            {
                isFetched && <ProductKits
                    kits={kits}
                    registerForm={registerForm}
                    addSkuLot={addSkuLot}
                    removeSkuLot={removeSkuLot}
                    productId={product?.productId}
                    isLoading={isLoading}
                />
            }
        </>
    )
}
